import React, { useState, useEffect } from "react";
import adminService from "../services/adminService";
import roleService from "../services/roleService";
import AddUserForm from "../components/AddUserForm";
import RoleManagementForm from "../components/RoleManagementForm";
import { useStateContext } from "../contexts/ContextProvider";
import { FaEdit, FaTrashAlt, FaUnlockAlt } from "react-icons/fa";
import userService from "../services/userService";
import { FaUnlock } from "react-icons/fa";
import EmailUnlockForm from "../components/EmailUnlockForm";

const AdminManage = () => {
  const [admins, setAdmins] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAddUserForm, setShowAddUserForm] = useState(false);
  const [showRoleManagementForm, setShowRoleManagementForm] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [roles, setRoles] = useState([]);
  const { currentColor, currentMode } = useStateContext();
  const [showEmailUnlockForm, setShowEmailUnlockForm] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");

  useEffect(() => {
    fetchAdmins();
    fetchRoles();
  }, []);

  const fetchAdmins = async (search = "", filter = "") => {
    try {
      const adminFilter = {
        start_user: 0,
        end_user: 20,
        search_filter: true,
        // searchValue: "",
        // filterByRoleType: "superadmin",
        searchValue: search,
        filterByRoleType: filter ? [filter] : [],
      };
      const data = await adminService.listAdmins(adminFilter);
      setAdmins(data);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const data = await adminService.listofManager();
      setRoles(data);
      console.log(data, "rolesssssss");
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const handleEdit = (admin) => {
    setSelectedAdmin(admin);
    setShowAddUserForm(true);
    setShowModal(true);
  };

  const handleDelete = async (adminId) => {
    try {
      await adminService.deleteAdmin(adminId);
      fetchAdmins();
    } catch (error) {
      console.error("Error deleting admin:", error);
    }
  };

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      console.log("submittinggggggg");
      if (selectedAdmin) {
        // If selectedAdmin exists, update the admin
        await adminService.updateAdmin(selectedAdmin._id, values);
      } else {
        // If selectedAdmin does not exist, add a new admin
        await adminService.addAdmin(values);
      }
      setSubmitting(false);
      setShowModal(false);
      setShowAddUserForm(false);
      fetchAdmins(); // Assuming fetchAdmins() fetches the updated admin list
    } catch (error) {
      console.error("Error:", error);
      // Optionally handle error state or display error message
    }
  };

  const handleAddRole = async (values, { setSubmitting, resetForm }) => {
    try {
      await roleService.addRole(values);
      setSubmitting(false);
      resetForm();
      fetchRoles();
    } catch (error) {
      console.error("Error adding role:", error);
      setSubmitting(false);
    }
  };

  const handleUpdateRole = async (values, { setSubmitting, resetForm }) => {
    try {
      await roleService.updateRole(values.selectedRole, {
        name: values.updatedRoleName,
      });
      setSubmitting(false);
      resetForm();
      fetchRoles();
    } catch (error) {
      console.error("Error updating role:", error);
      setSubmitting(false);
    }
  };

  const openAddUserForm = () => {
    if (!showAddUserForm) {
      setSelectedAdmin(null);
      setShowAddUserForm(true);
      setShowRoleManagementForm(false);
    }
    setShowModal(true);
  };

  const openRoleManagementForm = () => {
    setShowAddUserForm(false);
    setShowRoleManagementForm(true);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowAddUserForm(false);
    setShowRoleManagementForm(false);
    setShowEmailUnlockForm(false);
  };
  const openEmailUnlockForm = () => {
    setShowAddUserForm(false);
    setShowRoleManagementForm(false);
    setShowEmailUnlockForm(true);
    setShowModal(true);
  };
  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    fetchAdmins(event.target.value);
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
    fetchAdmins(searchValue, event.target.value);
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Management</h1>
      <div className="flex justify-between items-center mb-4">
        <div className="flex space-x-2">
          <select
            className="px-4 py-1 border rounded"
            value={selectedFilter}
            onChange={handleFilterChange}
          >
            <option value="">All Roles</option>
            {roles.map((role) => (
              <option key={role._id} value={role.name}>
                {role.name}
              </option>
            ))}
          </select>
          <input
            type="text"
            className="px-2 py-1 border rounded"
            placeholder="Search..."
            value={searchValue}
            onChange={handleSearchChange}
          />
        </div>

        <div className="flex items-center">
          <button
            className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
            onClick={openEmailUnlockForm}
            style={{ backgroundColor: currentColor, marginRight: "25px" }}
          >
            <FaUnlockAlt style={{ fontSize: "20px" }} />
          </button>
          <button
            className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
            onClick={() => setShowModal(true)}
            style={{ backgroundColor: currentColor }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {admins.map((admin) => (
          <div
            key={admin._id}
            className={`p-4 rounded-lg shadow-md cursor-pointer ${
              currentMode === "Dark" ? "text-white bg-[#33373E]" : "bg-white"
            }`}
          >
            <h2 className="text-xl font-bold">
              {admin.firstname} {admin.lastname}
            </h2>
            <p>
              <strong>Email:</strong> {admin.email}
            </p>
            <p>
              <strong>Role:</strong> {admin.role[0].role}
            </p>
            <p>
              <strong>Status:</strong> {admin.status}
            </p>
            <div className="flex space-x-2 mt-4 justify-end">
              <button
                className="px-2 py-2 text-white rounded-full transition duration-300 ease-in-out hover:bg-gray-700"
                style={{ backgroundColor: currentColor }}
                onClick={() => handleEdit(admin)}
              >
                <FaEdit />
              </button>

              <button
                className="px-2 py-2 bg-red-500 text-white rounded-full hover:bg-red-600"
                onClick={() => handleDelete(admin._id)}
              >
                <FaTrashAlt />
              </button>
            </div>
          </div>
        ))}
      </div>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {showAddUserForm
                  ? "Add Admin"
                  : showRoleManagementForm
                  ? "Role Management"
                  : showEmailUnlockForm
                  ? "Unlock Account"
                  : "Add Admin or Manage Roles"}
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={() => closeModal()}
              >
                &times;
              </button>
            </div>
            <div className="d-flex justify-content-center">
              {showAddUserForm ? (
                <AddUserForm
                  roles={roles}
                  selectedUser={selectedAdmin}
                  handleFormSubmit={handleFormSubmit}
                />
              ) : showRoleManagementForm ? (
                <RoleManagementForm
                  roles={roles}
                  handleAddRole={handleAddRole}
                  handleUpdateRole={handleUpdateRole}
                  closeModal={closeModal}
                />
              ) : showEmailUnlockForm ? (
                <EmailUnlockForm closeModal={closeModal} />
              ) : (
                <div className="flex flex-col items-center">
                  <button
                    className="mb-3 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    onClick={openAddUserForm}
                  >
                    Add Admin
                  </button>
                  <button
                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                    onClick={openRoleManagementForm}
                  >
                    Role Management
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminManage;
